import { coverList } from '@/pages/home/data';

function SectionHead({
  idx,
  kicker,
  title,
  desc,
  anchor,
}: {
  idx: string;
  kicker: string;
  title: string;
  desc: string;
  anchor: string;
}) {
  return (
    <div className="mb-8 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <div className="flex items-center gap-3 text-xs font-semibold uppercase tracking-widest text-secondary-600">
          <span className="font-display text-sm font-black text-primary-500">{idx}</span>
          <span className="h-px w-6 bg-background-400" />
          {kicker}
        </div>
        <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
      </div>
      <p className="max-w-md text-sm leading-6 text-foreground-600">{desc}</p>
    </div>
  );
}

export default function CoverLibrary() {
  return (
    <section id="cover" className="scroll-mt">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <SectionHead
          idx="01"
          kicker="封面风格档案"
          title="黑料色封面收藏夹"
          desc="每一条都是一版可复用的封面逻辑：标题放哪、留白多少、暗调压多深。标题配一句摘要，翻得快、抄得也快。"
          anchor="cover"
        />

        <div className="flex flex-col gap-4">
          {coverList.map((c, i) => (
            <a
              key={c.id}
              href="#cover"
              className="group grid cursor-pointer grid-cols-1 items-stretch overflow-hidden rounded-lg border border-background-300/60 bg-background-50 transition-colors hover:border-primary-300 sm:grid-cols-12"
            >
              <div className="sm:col-span-4 lg:col-span-3">
                <div className="relative h-52 w-full overflow-hidden bg-background-200 sm:h-full">
                  <img
                    src={c.img}
                    alt={`黑料色${c.title}`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 flex h-8 w-8 items-center justify-center rounded-md bg-foreground-950/85 font-display text-sm font-black text-background-50">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                </div>
              </div>
              <div className="flex flex-col justify-center gap-3 p-5 sm:col-span-8 sm:p-6 lg:col-span-9 lg:p-8">
                <div className="flex items-center gap-2">
                  <span className="flex h-6 items-center whitespace-nowrap rounded-full bg-secondary-100 px-2.5 text-xs font-medium text-secondary-800">
                    {c.cat}
                  </span>
                  <span className="hidden text-xs text-foreground-400 md:block">编号 / {c.id}</span>
                </div>
                <h3 className="font-display text-lg font-bold text-foreground-950 md:text-xl">
                  {c.title}
                </h3>
                <p className="max-w-2xl text-sm leading-6 text-foreground-600 md:text-[15px] md:leading-7">
                  {c.summary}
                </p>
                <div className="flex flex-wrap items-center gap-2">
                  {c.tags.map((t) => (
                    <span
                      key={t}
                      className="flex h-6 cursor-pointer items-center whitespace-nowrap rounded-full border border-background-300/70 bg-background-50 px-2.5 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
                    >
                      {t}
                    </span>
                  ))}
                </div>
                <div className="flex flex-wrap items-center justify-between gap-2 border-t border-background-300/60 pt-3 text-xs text-foreground-500">
                  <div className="flex items-center gap-4">
                    <span className="flex items-center gap-1 text-accent-600">
                      <i className="ri-fire-fill text-[13px]" />
                      热度 {c.heat}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-bookmark-line text-[13px]" />
                      {(c.save / 1000).toFixed(1)}k 人收藏
                    </span>
                  </div>
                  <span className="flex items-center gap-1 whitespace-nowrap font-medium text-primary-600 transition-colors group-hover:gap-2">
                    进档案看看
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}